import React, { useCallback, useContext, useEffect, useReducer, useState } from 'react'
import { dataLayerPush } from '../helperFunctions'
import { stepEnums } from '../static'
import { OptionsContext } from './OptionsContext'

export const StepperContext = React.createContext({
    step: 0,
    dispatchStep: (type: string, choice?: string) => {
    },
    flow: '',
    isUpdateRequest: false,
    dctResultsError: false,
    setIsUpdateRequest: (isUpdateRequest: boolean) => {
    }
  }
)

const handleDataLayerLanding = (step: number) => {
  dataLayerPush(stepEnums[step as keyof typeof stepEnums], 'landed')
}
const StepperContextProvider = (props: { children: React.ReactNode }) => {
  
  const { directFlow } = useContext(OptionsContext)
  
  const [flow, setFlow] = useState(directFlow || 'completeAdvice')
  const [dctResultsError, setDctResultsError] = useState(false)
  const [isUpdateRequest, setIsUpdateRequest] = useState(false)
  
  const reducer = useCallback((step: number, action: { type: string, choice?: string }) => {
    
    const step2Branching = () => {
      setFlow(action.choice || '')
      
      return action.choice === 'solar' ? 10 : 3
    }
    
    switch (action.type) {
      case 'next':
        if (step === 1 && directFlow) {
          setFlow(directFlow)
          
          return directFlow === 'solar' ? 10 : 3
        } else return step + 1
      case 'back':
        if(step === 3 && directFlow) return 1
        else return step - 1
      case 'start':
        return 1
      case 'dct_back':
        return directFlow ? 1 : 2
      case 'step2Branching':
        return step2Branching()
      case 'addressError':
        return 8
      case 'dct_results_err':
        setDctResultsError(true)
        
        return 15
      case 'dct_results_err_back':
        return 11
      case 'dct_offer_confirmation':
        return 7
      case 'dct_full_offer':
        return 15
      case 'redirect_personal_info':
        setIsUpdateRequest(true)
        setFlow('completeAdvice')
        
        return 6
      case 'dct_start':
        return 10
      default:
        throw new Error()
    }
  }, [directFlow])
  
  const [step, dispatch] = useReducer(reducer, 1)
  
  useEffect(() => handleDataLayerLanding(step), [step])
  
  const dispatchStep = useCallback((type: string, choice?: string) => dispatch({ type, choice }), [])
  
  return (
    <StepperContext.Provider value={{ step, dispatchStep, flow, isUpdateRequest, setIsUpdateRequest, dctResultsError }}>
      {props.children}
    </StepperContext.Provider>
  )
}

export default StepperContextProvider
